export default __webpack_public_path__ + "static/media/minus_icon.a3b1a6ba.svg";